import { getModel } from "../../utils/models";
import SalesLogos from "./SalesLogos";

const SupportInfo = ({ everpassLogo = false, coBrandedLogo, landing = false }) => {
    const model = getModel();
    const linkClass = landing ? "span-semi-bold support-link" : "span-semi-bold";

    switch (model) {
        case "xumo":
            return (
                <>
                    <div className="contact-info-text">
                        <div>Need help accessing to your account?</div>
                        <div>
                            Visit <span className={linkClass}>{process.env.REACT_APP_XUMO_INFO_SHORTEN_LINK}</span>
                            &nbsp; or call <span className="span-semi-bold">{process.env.REACT_APP_SPECTRUM_HELP_DESK_NUMBER}</span>
                        </div>
                        <div className="support-logos">
                            {everpassLogo && <SalesLogos coBrandedLogo={coBrandedLogo} />}
                        </div>
                    </div>
                </>
            );
        case "xi6":
        case "xid":
        case "xg2v2":
            return (
                <div className="contact-info-text">
                    <div>Need help accessing to your account?</div>
                    <div>
                        Visit <span className={linkClass}>{process.env.REACT_APP_COMCAST_INFO_SHORTEN_LINK}</span>
                        &nbsp; or call <span className="span-semi-bold">{process.env.REACT_APP_COMCAST_HELP_DESK_NUMBER}</span>
                    </div>
                    <div className="support-logos">
                        {everpassLogo && <SalesLogos coBrandedLogo={coBrandedLogo} />}
                    </div>
                </div>
            );
        default:
            return (
                <>
                    <div className="contact-info-text">
                        <div>Need help accessing to your account?</div>
                        <div>
                            Visit <span className={linkClass}>help.everpass.com</span>
                        </div>
                        <div className="support-logos">
                            {everpassLogo && <SalesLogos coBrandedLogo={coBrandedLogo} />}
                        </div>
                    </div>
                </>
            );
    }
};

export default SupportInfo;